import { render, staticRenderFns } from "./ViewMore.vue?vue&type=template&id=2a374f19&scoped=true&"
import script from "./ViewMore.vue?vue&type=script&lang=js&"
export * from "./ViewMore.vue?vue&type=script&lang=js&"
import style0 from "./ViewMore.vue?vue&type=style&index=0&id=2a374f19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a374f19",
  null
  
)

export default component.exports